import React, { useEffect, useState } from 'react'
import { Box, Button, Collapse, Grid, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useDispatch } from 'react-redux'
import Countdown, { CountdownRenderProps } from 'react-countdown'
import moment from 'moment'
import { Modal } from '../../../../components'

const Renderer: React.FC<CountdownRenderProps> = ({ hours, minutes }) => {
  return (
    <>
      <span>{hours}&nbsp;ч.&nbsp;</span>&nbsp;
      <span>{minutes}&nbsp;мин.&nbsp;</span>
    </>
  )
}

const Timer: React.FC<{ timeEnd: number }> = ({ timeEnd = 0 }) => {
  return <Countdown date={timeEnd} renderer={(props) => <Renderer {...props} />} />
}

export const OutListModal: React.FC<{
  data: any
  show: boolean
  onClose: () => void
  onConfirm: () => void
}> = ({ data = [], show = false, onConfirm = () => {}, onClose = () => {} }): JSX.Element => {
  const classes = useStyles()

  const now = new Date()
  const start = moment(now).valueOf() + 43200000

  const [collapse, setCollapse] = useState<boolean>(true)

  const onCloseModal = () => {
    onClose()
    setCollapse(false)
  }

  const onConfirmModal = () => {
    onConfirm()
    setCollapse(false)
  }

  useEffect(() => {
    if (!collapse) {
      setTimeout(() => setCollapse(true), 200)
    }
  }, [collapse])

  return (
    <Modal open={show} maxWidth="sm" onClose={onCloseModal}>
      <Collapse in={collapse}>
        <Box mt={6}>
          <Box className={classes.text}>
            <Box>Вы можете выйти из чек-листа и вернуться позже, заполненные данные будут сохранены.</Box>
            {data.end_datetime && (
              <>
                <Box mt={3}>До окончания заполнения чек-листа осталось:</Box>
                <Box fontWeight={700} fontSize="120%" color="#E21222">
                  <Timer timeEnd={data.end_datetime !== null ? moment(data.end_datetime).valueOf() : start} />
                </Box>
              </>
            )}
          </Box>
          <Grid container justifyContent="center">
            <Grid item>
              <Button variant="contained" color="secondary" onClick={onConfirmModal} className={classes.btn}>
                Ок
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Collapse>
    </Modal>
  )
}

const useStyles = makeStyles(({ font, breakpoints: { down }, palette }: Theme) => ({
  btn: {
    fontSize: '16px!important',
    padding: '10px 20px!important',
    minHeight: '45px!important',
    minWidth: '150px!important',
    [down('md')]: {
      fontSize: '15px!important',
      padding: '10px 25px!important',
      minHeight: '35px!important',
      minWidth: '130px!important',
    },
  },
  text: {
    fontSize: 17,
    textAlign: 'left',
    padding: '0 50px 40px',
    [down('sm')]: {
      fontSize: 15,
    },
  },
}))
